module.exports = __webpack_public_path__ + "img/limited_edition_giclee.b6d54824.jpg";